// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__12hDB","insightsList":"newBusinessInsightsMenu_insightsList__3fqOv","active":"newBusinessInsightsMenu_active__20hzx"};